module.exports = __webpack_public_path__ + "static/media/Noemi_Rodriguez_Vega.6028234b.jpg";